'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$32() {
  this.bCb = null;
  this.bCc = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$32 as $c_Lpresto_TwoFactorAuthView$$anon$32 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$32;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$32() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$32 as $h_Lpresto_TwoFactorAuthView$$anon$32 };
$h_Lpresto_TwoFactorAuthView$$anon$32.prototype = $p;
$p.P = (function() {
  if ((!this.bCc)) {
    this.bCb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bCc = true;
  }
  return this.bCb;
});
var $d_Lpresto_TwoFactorAuthView$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$32, "presto.TwoFactorAuthView$$anon$32", ({
  Su: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$32 as $d_Lpresto_TwoFactorAuthView$$anon$32 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$32.js.map
